export const FIRM_DOCUMENT_SUGGESTIONS_QUERY_KEY = 'firm-document-suggestions';
export const FIRM_DOCUMENT_SUGGESTIONS_QUERY_LIMIT = 8;
export const FIRM_DOCUMENT_SUGGESTIONS_QUERY_MIN_SEARCH_LENGTH = 2;
export const FIRM_DOCUMENT_SUGGESTIONS_QUERY_STALE_TIME_MS = 30_000;
